import React from "react";
import "@/App.css";
import { AppProvider } from "./context/AppContext";
import { Header } from "./components/Header";
import { FilterPanel } from "./components/FilterPanel";
import { AEDList } from "./components/AEDList";
import { IntelligencePanel } from "./components/IntelligencePanel";
import { AEDDetailModal } from "./components/AEDDetailModal";
import { Toaster } from "./components/ui/sonner";

const Dashboard = () => {
  return (
    <div className="w-full h-screen overflow-hidden bg-radial-dark hud-grid" data-testid="dashboard">
      {/* Scan line effect */}
      <div className="scan-line" />
      
      {/* Header */}
      <Header />
      
      {/* Main Content - 3 Panel Layout */}
      <div className="grid grid-cols-12 gap-4 p-4 h-[calc(100vh-56px)]">
        {/* Left Panel - Filters */}
        <aside className="col-span-12 md:col-span-3 lg:col-span-2 h-full overflow-hidden" data-testid="filter-panel">
          <FilterPanel />
        </aside>
        
        {/* Center Panel - AED List */}
        <main className="col-span-12 md:col-span-6 lg:col-span-7 h-full overflow-hidden" data-testid="aed-list-panel">
          <AEDList />
        </main>
        
        {/* Right Panel - Intelligence */}
        <aside className="col-span-12 md:col-span-3 lg:col-span-3 h-full overflow-hidden" data-testid="intelligence-panel">
          <IntelligencePanel />
        </aside>
      </div>
      
      {/* Detail Modal */}
      <AEDDetailModal />
    </div>
  );
};

function App() {
  return (
    <AppProvider>
      <Dashboard />
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#0f172a',
            border: '1px solid #1e293b',
            color: '#e2e8f0'
          }
        }}
      />
    </AppProvider>
  );
}

export default App;
